<template>
  <div>
    <CRow>
      <CCol  col="4">
        <div v-for="contact in contacts">
          <div @click="contact_id = contact.id" :class="`${contact.id==contact_id ? 'bg-success text-white' : 'bg-white text-black'} `">
           <div class="d-flex p-4 border-bottom">
             <img class="mx-1" :src="contact.image" style="width: 45px" />
          <div class="mx-1">
            <div>
              {{contact.name}}
            </div>
            <div>
              {{contact.email}}
            </div>
            <div>
              {{contact.phone}}
            </div>
          </div>
<div>
  <CBadge
      color="primary"
  >
    {{unread_list.filter(x=>x.from_id==contact.id)[0].count}}
  </CBadge>

</div>
           </div>
          </div>
        </div>
      </CCol>
      <CCol  col="8">
        <CCard>

          <CCardBody>
<div style="height: 70vh;overflow: auto" id="message_support_root" v-if="contact_id>0">
  <div v-for="msg in message_list">
    <div :class="`${msg.to_id==null ? 'my_message' : 'support_message'} admin-message`">
      <div class="font-weight-bold" v-if="msg.to_id==null">
        Customer

      </div>
      <div class="font-weight-bold" v-if="msg.from_id==null">
        You

      </div>
      <div>
        {{msg.message}}
      </div>
      <div>
        {{get_date_time(msg.created_at)  }}
      </div>

    </div>
  </div>

</div>
            <div>
              <CInput
                placeholder="message"
                v-model="message"
                @click.enter="send_message()"
                />
            </div>
            <CButton @click="send_message()"
                     color="primary"
            >
              Send
            </CButton>
          </CCardBody>

        </CCard>


      </CCol>
    </CRow>
    <!-- Modal for Add/Edit Line -->
  </div>

</template>

<script>
import axios from "axios";

import {bus} from '../../main';

export default {
  name: 'Login',
  components: {},
  data() {
    return {
      message:'',
      unread_list:[],
      contacts:[],
      message_list:[],
      contact_id:0,
    }
  },
  mounted() {
    this.get_contacts();
  },
  watch: {
    'contact_id':function (){
      this.get_messages()
    }
  },
  methods: {

    get_contacts() {
      var self = this;
var formData = new FormData();
      // get_admin_messages
      // send_admin_messages
      // read_admin_messages
      // count_admin_messages
      axios.post('/api/super-admin/site/get_contacts',formData, {}).then(function (response) {

        self.contacts = response.data.data;
        self.unread_list = response.data.unread;

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_messages() {
      var self = this;
var formData = new FormData();
      formData.append('contact_id',this.contact_id)
      axios.post('/api/super-admin/site/get_admin_messages',formData, {}).then(function (response) {


        self.message_list = response.data;
        setTimeout(function (){
          var objDiv = document.getElementById("message_support_root");
          objDiv.scrollTop = objDiv.scrollHeight;
        },300)

        bus.$emit('update_unread_message',{})
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    send_message() {
      var self = this;
var formData = new FormData();
      formData.append('contact_id',this.contact_id)
      if(this.message==''){
        return false;
      }
      formData.append('message',this.message)
      axios.post('/api/super-admin/site/send_admin_messages',formData, {}).then(function (response) {

        var content_cats = response.data;
if(response.data.error==0){
  self.message_list.push(
      {
        message:self.message,
        to_id:0,
        from_id:null,
        created_at:new Date(),
        updated_at:new Date(),

      }
  )
  self.message=''
  setTimeout(function (){
    var objDiv = document.getElementById("message_support_root");
    objDiv.scrollTop = objDiv.scrollHeight;
  },300)
}
        self.message_list = content_cats.orders.map((item, row_id) => {
          return {...item, row_id}
        })

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}


</script>

<style>

.admin-message{
color:black;
  border-radius: 5px;
  margin: 5px 10px;
  padding: 5px;
}
.admin-message.support_message{
background: #d9fdd3;
  max-width: 50%;
}
.admin-message.my_message{
background: white;
  max-width: 50%;
  justify-self: right;
border: 1px solid #80808054;

}
</style>